// client/src/components/BankStatementNav.js

import React from 'react';
import { NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';

const TABS = [
  { to: '/bank-statements/analyse', label: 'Analyse' },
  { to: '/bank-statements/transactions', label: 'Transactions' },
  { to: '/bank-statements/comptes', label: 'Comptes' },
  { to: '/bank-statements/import', label: 'Importer' },
  { to: '/bank-statements/categories', label: 'Catégories' },
  { to: '/bank-statements/manage', label: 'Gérer' }
];

function BankStatementNav() {
  const activeStyle = {
    backgroundColor: 'var(--color-accent)',
    color: '#fff',
    fontWeight: '600'
  };
  const inactiveStyle = { color: 'var(--color-secondary)' };

  return (
    <Nav variant="pills" className="flex-wrap gap-1 mb-4">
      {TABS.map((tab) => (
        <Nav.Item key={tab.to}>
          <Nav.Link
            as={NavLink}
            to={tab.to}
            style={({ isActive }) => (isActive ? activeStyle : inactiveStyle)}
          >
            {tab.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}

export default BankStatementNav;
